var render = function render(){var _vm=this,_c=_vm._self._c;return _c('component',_vm._b({},'component',_vm.wrapperOptions,false),[_vm._v(_vm._s(_vm.formattedContent))])
}
var staticRenderFns = []

export { render, staticRenderFns }